var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelLinkedin14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.114 5C10.192 5 11 5.698 11 7.199v2.8H9.362V7.387c0-.656-.237-1.104-.83-1.104-.452 0-.722.302-.84.594-.043.104-.054.25-.054.396V10H6l.001-.216c.002-.447.006-1.515.008-2.52V6.168c0-.527-.003-.932-.009-1.054h1.638v.692C7.855 5.474 8.245 5 9.114 5M5.5 5v5H4V5zm-.746-2c.456 0 .737.324.746.75 0 .417-.29.75-.754.75h-.009C4.289 4.5 4 4.167 4 3.75c0-.426.298-.75.754-.75"
}))));
export default SvgChannelLinkedin14;